import React from 'react' 
import Slider from "react-slick";

export default function Flags() {
    let settings = {
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000, 
        slidesToShow: 7,
        initialSlide: 1, 
  
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 1
          }
        }]
      };

  return (
    <>
  <section className="position-relative p70 flaglogo_setion text-center">
    <div className="container position-relative zindex">
      <h2 className="hadding ttu text-center mb-4 mb-md-5"> 
        <span>Flags</span>
      </h2>
      <Slider {...settings}>
      
          <div className="flag_box">
            <img src="img/flag/japan.png" alt="Japan" className="flaglogo" />
            <p>Japan</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/poland.png" alt="Poland" className="flaglogo" />
            <p>Poland</p>
          </div> 
        
          <div className="flag_box">
            <img
              src="img/flag/malaysia.png"
              alt="Malaysia"
              className="flaglogo"
            />
            <p>Malaysia</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/latvia.png" alt="Latvia" className="flaglogo" />
            <p>Latvia</p>
          </div> 
        
          <div className="flag_box">
            <img
              src="img/flag/vietnam.png"
              alt="Vietnam"
              className="flaglogo"
            />
            <p>Vietnam</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/israel.png" alt="Israel" className="flaglogo" />
            <p>Israel</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/boston.png" alt="Boston" className="flaglogo" />
            <p>Boston</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/china.png" alt="China" className="flaglogo" />
            <p>China</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/ukraine.png" alt="ukraine" className="flaglogo" />
            <p>Ukraine</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/russia.png" alt="Russia" className="flaglogo" />
            <p>Russia</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/belarus.png" alt="Belarus" className="flaglogo" />
            <p>Belarus</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/kazakhstan.png" alt="kazakhstan " className="flaglogo" />
            <p>Kazakhstan </p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Kyrgyzstan.png" alt="Kyrgyzstan" className="flaglogo" />
            <p>Kyrgyzstan</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/France.png" alt="France" className="flaglogo" />
            <p>France</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Nordic.png" alt="Nordic" className="flaglogo" />
            <p>Nordic</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Lithuania.png" alt="Lithuania" className="flaglogo" />
            <p>Lithuania</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Slovenia.png" alt="Slovenia" className="flaglogo" />
            <p>Slovenia</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/HongKong.png" alt="HongKong" className="flaglogo" />
            <p>HongKong</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/USA_Washington.png" alt="USA Washington" className="flaglogo" />
            <p>USA Washington</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Australia.png" alt="Australia" className="flaglogo" />
            <p>Australia</p>
          </div> 
    
        
          <div className="flag_box">
            <img src="img/flag/Estonia.png" alt="Estonia" className="flaglogo" />
            <p>Estonia</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/AsiaBlockchain.png" alt="Asia Blockchain" className="flaglogo" />
            <p>Asia Blockchain</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/EuropBlockchain.png" alt="Europ Blockchain" className="flaglogo" />
            <p>Europ Blockchain</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/AfricaBlockchain.png" alt="Africa Blockchain" className="flaglogo" />
            <p>Africa Blockchain</p>
          </div> 
          <div className="flag_box">
            <img src="img/flag/Korea.png" alt="Korea " className="flaglogo" />
            <p>Korea </p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Mongolia.png" alt="Mongolia" className="flaglogo" />
            <p>Mongolia</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/India.png" alt="India" className="flaglogo" />
            <p>India</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Taiwan.png" alt="Taiwan" className="flaglogo" />
            <p>Taiwan</p>
          </div>
       
          <div className="flag_box">
            <img src="img/flag/Thailand.png" alt="Thailand" className="flaglogo" />
            <p>Thailand</p>
          </div>
         
        
          <div className="flag_box">
            <img src="img/flag/Iran.png" alt="Iran" className="flaglogo" />
            <p>Iran</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Romania.png" alt="Romania" className="flaglogo" />
            <p>Romania</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Moldova.png" alt="Moldova" className="flaglogo" />
            <p>Moldova</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Serbia.png" alt="Serbia" className="flaglogo" />
            <p>Serbia</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Greece.png" alt="Greece" className="flaglogo" />
            <p>Greece</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Nepal.png" alt="Nepal" className="flaglogo" />
            <p>Nepal</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Argentina.png" alt="Argentina" className="flaglogo" />
            <p>Argentina</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Brazil.png" alt="Brazil" className="flaglogo" />
            <p>Brazil</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Bolivia.png" alt="Bolivia" className="flaglogo" />
            <p>Bolivia</p>
          </div> 
        
          <div className="flag_box">
            <img src="img/flag/Swiss.png" alt="Swiss" className="flaglogo" />
            <p>Swiss</p>
          </div> 
      </Slider>
     
     
    </div>
  </section>
    </>
  )
}
